module.exports = __webpack_public_path__ + "static/img/dps04.4ed8e0ea.png";